import { render, staticRenderFns } from "./DxPostWorkEmployeeManualHarvesting.vue?vue&type=template&id=024f887e&"
import script from "./DxPostWorkEmployeeManualHarvesting.vue?vue&type=script&lang=js&"
export * from "./DxPostWorkEmployeeManualHarvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports